import React from "react"
import { Link } from "gatsby"
import { graphql } from "gatsby"

import { Image } from "react-bootstrap"

import Layout from "../components/layout"
import SEO from "../components/seo"

const ActividadesPage = ({ data }) => (
    <Layout pageInfo={{ pageName: "Actividades", description: "Prueba" }}>
        <SEO title="Actividades" />
      <br />
      <br />
    <h1>Actividades</h1>
        {data.allNodeActividades.edges.map(({ node }) => (
            <div class="blog-card">
            <div class="meta">
              <div class="photo"><Image src={"https://dev-opensociallab.pantheonsite.io" + node.relationships.field_image.uri.url} alt={node.field_nombre} fluid /></div>
            </div>
            <div class="description">
              <h1>{node.title}</h1>
        <h2>{node.relationships.field_campus.name} <small>{node.created}</small></h2> 
              <p  dangerouslySetInnerHTML={{ __html: node.body.summary.split(' ').splice(0, 45).join(' ') + '...' }}></p>
              <p class="read-more">
              <Link to={node.path.alias}>Leer más</Link> 
              </p>
            </div>
          </div>
    
    ))}
    </Layout>
)

export default ActividadesPage

export const query = graphql`
 query allNodeActividades {
  allNodeActividades( sort: {order: DESC, fields: created}) {
    edges{
      node{
        title
        created(formatString: "DD-MMM-YYYY")
        id
        relationships {
          field_campus {
            name
          }
          field_tags {
            name
          }
          field_image {
            uri {
              url
            }
          }
        }
        body {
          value
          summary
        }
        path {
          alias
        }
      }
  }
  }
  }
`